import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetSalesRepReport = () => {
  const Api = useApi()
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const initialFilters = {
    page: 1,
    limit: 100,
    sort_by: 'total_discount/-1',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'),
    sales_rep_type: '',
  }

  const {filters, onSearch, onSortingChange, onPageChange, onDateChange, setMultipleFilters} =
    useFilters(initialFilters, {sortType: 'number'})

  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/order-discount/report/sales-rep',
    {
      queryId: 'discount-sales-rep-report',
      filters,
    }
  )

  const onChangeSalesRepTypeFilter = (values: any[]) => {
    setMultipleFilters({
      sales_rep_type: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
  }

  return {
    reportData: response?.data || [],
    pagination: response?.pagination || {},
    isLoading: isFetching,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    onDateChange,
    onChangeSalesRepTypeFilter,
  }
}

export default useGetSalesRepReport
